/*
 * Accordion styling and state.
 */
import './tabs.scss';
import Tabs from '@10up/component-tabs';

if ( typeof window.ITOLTabBlock !== 'object' ) {
	window.ITOLTabBlock = {};
}

window.ITOLTabBlock.Tab = Tabs;

function createTabs(selector) {

	const tabBlocks = document.querySelectorAll(selector);

	[...tabBlocks].forEach( block => {
		let tabsArray = [];

		const tabList = block.querySelector('.tab-list');
		const tabContents = block.querySelectorAll('.tab-content');

		tabList.innerHTML = '';

		[...tabContents].forEach( content => {
		const tabData = content.dataset;
			tabsArray.push( {
				id: tabData.id,
				label: tabData.label,
				prefix: tabData.labelPrefix,
				suffix: tabData.labelSuffix,
				icon: tabData.labelIcon,
				iconPosition: tabData.labelIconPosition
			} );
		});

		// tabsArray.forEach( tab => {
		// 	tabList.innerHTML += `<li class="tab-item ${tab.iconPosition}"><span>${tab.prefix}</span><button role="tab" aria-controls="js-tab${tab.id}-${tab.label}">${tab.label}</button><span>${tab.suffix}</span><img src="${tab.icon}" /></li>`;
		// } )
		tabsArray.forEach( tab => {
			tabList.innerHTML += `<li class="tab-item ${tab.iconPosition}"><button role="tab" aria-controls="js-tab${tab.id}-${tab.label}"><span>${tab.prefix}</span>${tab.label}<span>${tab.suffix}</span><img src="${tab.icon}" /></button></li>`;
		} )
	})

	
}

function tabsInit() {

	// createTabs('.tabs');
	// console.log('poopie');

	// const tabs = document.querySelectorAll('.tabs');
	// const tabsVertical = document.querySelectorAll('.tabs-vertical');

	// console.log(tabs);

	// [...tabs].forEach( tabBlock => {
	// 	console.log(tabBlock, tabBlock.id)

	const tabBlocks = document.querySelectorAll('.tabs');
	const tabBlocksVertical = document.querySelectorAll('.tabs-vertical');


	if ( tabBlocks ) {
		createTabs('.tabs');

		new Tabs( '.tabs', {
			onCreate: function() {
				//console.log( 'onCreate callback' );
			},
			onTabChange: function() {
				//console.log( 'onTabChange callback' );
			}
		} );
	}

	if ( tabBlocksVertical ) {
		createTabs('.tabs-vertical');

		new Tabs( '.tabs-vertical', {
			orientation: 'vertical',
			onCreate: function() {
				//console.log( 'onCreate callback' );
			},
			onTabChange: function() {
				//console.log( 'onTabChange callback' );
			}
		} );
	}
}

document.addEventListener( 'DOMContentLoaded', () => {
	if ( window.acf ) {
		window.acf.addAction( 'render_block_preview', tabsInit );
	} else {
		tabsInit();
	}
} );
